module.exports = __webpack_public_path__ + "img/stake-new.6222c7e8.svg";